import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import useProfile from "./useProfile";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import { useDispatch, useSelector } from "react-redux";

export default function () {
  const { reset, handleSubmit, setErrors, editProfileFields, setData } = useProfile();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);

  useEffect(() => {
    axios.get('/profile/edit').then(res => {
      reset(res.data.user);
    });
  }, []);

  const editProfile = data => {
    const formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      formData.append(`${property}`, value || '');
    });

    formData.append("_method", "PUT");

    axios.post('/profile', formData)
      .then(function (res) {
        if (res.status == 200) {
          swal('Your profile has been updated successfully!', {
            icon: "success",
          });
          dispatch({
            type: 'PUT_USER', user: {
              ...user,
              avatar: res?.data?.user?.avatar,
              email: res?.data?.user?.email
            }
          });
          navigate("/");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit My Profile">
      <form className="form w-100 row" onSubmit={handleSubmit(editProfile)}>
        {editProfileFields}

        <SubmitButton title="Update" classes="d-inline-block w-auto" />
      </form>
    </Card>
  );
}